<template>
    <div class="appointment">
        <page-title pageName="场地使用效能统计"></page-title>
        <Space></Space>
        <div class="topBtns">
            <div class="search">
                <el-select v-if="isadmin" v-model="tradeOrgId" clearable placeholder="请选择">
                    <el-option
                        v-for="item in tradeOrgList"
                        :key="item.id"
                        :label="item.orgName"
                        :value="item.id"
                    ></el-option>
                </el-select>
                <el-select v-model="placeType" placeholder="请选择场地" @change="searchClick">
                    <el-option
                        v-for="(item,index) in placeTypeList"
                        :key="index"
                        :label="item.text"
                        :value="item.id"
                    ></el-option>
                </el-select>
                <el-input
                    class="my_input"
                    placeholder="请输入场地编号/名称"
                    v-model="searchKey"
                    @keyup.enter.native="searchClick"
                    clearable
                ></el-input>
                <el-button plain size="small" @click="searchClick">搜索</el-button>
                <el-button type="primary" size="small" @click="refresh">刷新</el-button>
            </div>
        </div>
        <Space></Space>

        <el-table
            class="table-content"
            :data="dataList.slice((pageIndex-1)*pageSize,pageIndex*pageSize)"
            :header-cell-style="{'background':'#f5f7fa'}"
            v-loading="dataListLoading"
            ref="multipleTable"
            stripe
            border
        >
            <el-table-column fixed type="selection" align="center"></el-table-column>
            <el-table-column
                fixed
                label="序号"
                type="index"
                width="50"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                label="场地名称"
                prop="fieldName"
                header-align="center"
                align="left"
                min-width="150"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                label="场地编号"
                prop="fieldCode"
                header-align="center"
                align="center"
                min-width="80"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                label="场地类型"
                prop="fieldTypeName"
                header-align="center"
                align="center"
                width="120"
            ></el-table-column>
            <el-table-column
                label="使用频率"
                prop="useRate"
                header-align="center"
                align="right"
                min-width="100"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{scope.row.useRate}}</span>
                    <span class="unit-class">&nbsp;次/工作日</span>
                </template>
            </el-table-column>
            <el-table-column
                label="本月使用次数"
                prop="monUseNumber"
                header-align="center"
                align="right"
                min-width="80"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{scope.row.monUseNumber}}</span>
                    <span class="unit-class">&nbsp;次</span>
                </template>
            </el-table-column>
            <el-table-column
                label="累计使用时长(月度)"
                prop="useTotalTimes"
                header-align="center"
                align="right"
                min-width="70"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{scope.row.monuseTotalTimes}}</span>
                    <span class="unit-class">&nbsp;小时</span>
                </template>
            </el-table-column>
            <el-table-column
                label="单次平均使用时长(月度)"
                prop="avgOneuseTimes"
                header-align="center"
                align="right"
                min-width="80"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{scope.row.monavgOneuseTimes}}</span>
                    <span class="unit-class">&nbsp;小时/次</span>
                </template>
            </el-table-column>
            <el-table-column
                label="本年使用次数"
                prop="yearUseNumber"
                header-align="center"
                align="right"
                min-width="80"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{scope.row.yearUseNumber}}</span>
                    <span class="unit-class">&nbsp;次</span>
                </template>
            </el-table-column>

            <el-table-column
                label="累计使用时长(年度)"
                prop="useTotalTimes"
                header-align="center"
                align="right"
                min-width="70"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{scope.row.useTotalTimes}}</span>
                    <span class="unit-class">&nbsp;小时</span>
                </template>
            </el-table-column>
            <el-table-column
                label="单次平均使用时长(年度)"
                prop="avgOneuseTimes"
                header-align="center"
                align="right"
                min-width="80"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{scope.row.avgOneuseTimes}}</span>
                    <span class="unit-class">&nbsp;小时/次</span>
                </template>
            </el-table-column>
        </el-table>
        <!--        <el-pagination-->
        <!--                @size-change="sizeChangeHandle"-->
        <!--                @current-change="currentChangeHandle"-->
        <!--                :current-page="pageIndex"-->
        <!--                :page-sizes="[10, 20, 50, 100]"-->
        <!--                :page-size="pageSize"-->
        <!--                :total="total"-->
        <!--                layout="total, sizes, prev, pager, next, jumper"/>-->
        <div class="line-middle">
            <div class="tabs-line">
                <div :class="{'actived':tabs==1}" @click="tabChange(1)">本月</div>
                <div :class="{'actived':tabs==2}" @click="tabChange(2)">本年</div>
            </div>
            <div class="line-echarts">
                <div ref="unitLine1" class="chart-box1"></div>
                <div>
                    <table class="table-unit" border>
                        <tr v-for="(item,index) in lineData" :key="index">
                            <td style="width:40px">
                                <span></span>
                            </td>
                            <td
                                v-for="(items,indexs) in item"
                                :key="indexs"
                                :style="{'width':tdWidth}"
                            >
                                <template v-if="index==0">{{items}}次</template>
                                <template v-else>{{items}}小时/次</template>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "echarts-liquidfill";
import { mapState } from "vuex";
import * as echarts from "echarts/core";
import { BarChart, CustomChart, HeatmapChart } from "echarts/charts";
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    DatasetComponent,
    GeoComponent,
    VisualMapComponent,
    DatasetComponentOption,
    TransformComponent
} from "echarts/components";
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from "echarts/features";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";
import Space from '@/components/space.vue'
import pageTitle from '@/components/pageTitle.vue'
// 注册必须的组件
echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    BarChart,
    GeoComponent,
    CustomChart,
    VisualMapComponent,
    LegendComponent,
    HeatmapChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer
]);
export default {
    name: "list",
    components:{
        pageTitle,
        Space 
    },
    data() {
        return {
            dataList: [],
            tableMaxHeight: 280,
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            dataListLoading: false,
            searchKey: "",
            placeType: "1",
            tradeOrgId: "",
            tabs: 1,
            tdWidth: "auto",
            lineData: []
        };
    },
    created() {
        this.$store.dispatch("region/getPlaceType", "");
        this.$store.dispatch("region/getTradeOrgList");
    },
    computed: {
        ...mapState({
            placeTypeList: state => state.region.placeTypeList,
            tradeOrgList: state => state.region.tradeOrgList,
            isadmin: state => state.user.supperAdmin
        })
    },
    methods: {
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
        },
        tabChange(tab) {
            this.tabs = tab;
            this.lineEchartData(this.dataList);
        },
        getDataList() {
            this.dataListLoading = true;
            this.$http
                .post("/field/usereport/list", {
                    page: this.pageIndex,
                    rows: 1000,
                    searchKey: this.searchKey,
                    filter: {
                        fieldType: this.placeType,
                        tradeOrgId: this.tradeOrgId
                    }
                })
                .then(({ data }) => {
                    this.dataListLoading = false;
                    if (data) {
                        this.dataList = data.rows;
                        this.total = data.total;
                        this.lineEchartData(this.dataList);
                    } else {
                        this.dataList = [];
                        this.totalPage = 0;
                    }
                });
        },
        searchClick() {
            this.getDataList();
        },
        refresh() {
            this.$http
                .post("/field/usereport/archivesReport")
                .then(({ data }) => {
                    if (data.code != 1) {
                        this.$message.error(data.msg);
                        return;
                    }
                    this.getDataList();
                });
        },
        lineEchartData(data) {
            var fieldNameArr = [],
                useTimeM = [],
                useTimeY = [],
                useCountY = [],
                useCountM = [];

            data.forEach(item => {
                fieldNameArr.push(item.fieldName);
                useTimeM.push(item.monavgOneuseTimes);
                useTimeY.push(item.avgOneuseTimes);
                useCountM.push(item.monUseNumber);
                useCountY.push(item.yearUseNumber);
            });
            this.lineData =
                this.tabs == 1 ? [useCountM, useTimeM] : [useCountY, useTimeY];
            this.$nextTick(() => {
                this.tableWidth();
            });

            var option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        crossStyle: {
                            color: "#999"
                        }
                    }
                },
                grid: {
                    left: 48,
                    bottom: 30,
                    right: 48
                },
                legend: {
                    itemHeight: 10,
                    itemWidth: 10
                },
                color: ["rgba(91, 143, 249, 0.85)", "rgba(90, 216, 166, 0.85)"],
                xAxis: [
                    {
                        type: "category",
                        data: fieldNameArr,
                        axisPointer: {
                            type: "shadow"
                        },
                        axisTick: {
                            lineStyle: {
                                color: "#EEEEEE"
                            },
                            length: 30
                        },
                        axisLabel: {
                            fontSize: 12,
                            margin: 12,
                            color: "rgba(0, 0, 0, 0.85)"
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位/次",
                        min: 0,
                        axisLabel: {
                            width: 40,
                            formatter: "{value} "
                        }
                    },
                    {
                        type: "value",
                        name: "单位/小时",
                        min: 0,
                        axisLabel: {
                            width: 40,
                            formatter: "{value}"
                        }
                    }
                ],
                series: [
                    {
                        name: "使用次数",
                        type: "bar",
                        data: this.tabs == 1 ? useCountM : useCountY
                    },
                    {
                        name: "单次使用平均时间",
                        type: "bar",
                        yAxisIndex: 1,
                        data: this.tabs == 1 ? useTimeM : useTimeY
                    }
                ]
            };
            var chartBar = echarts.init(this.$refs.unitLine1);
            chartBar.setOption(option);
            window.addEventListener("resize", () => {
                chartBar.resize();
                this.tableWidth();
            });
        },
        tableWidth() {
            var tdArr = document.querySelectorAll(".line-echarts td");
            var index = this.lineData[0].length;
            if (index == 0) {
                return;
            }
            var tdWidth =
                (document.querySelectorAll(".chart-box1")[0].offsetWidth - 80) /
                    index +
                "px";
            this.tdWidth = tdWidth;
        }
    },
    activated() {
        this.getDataList();

        this.$refs.multipleTable.doLayout();
    }
};
</script>

<style lang="scss" scoped>
$main-color: #2568ec;
.appointment{
    padding: 0 16px 16px;
    .topBtns{
        display: flex;
        margin:16px 0;
        .searchKey{
            width: 200px;
        }
        .el-button--medium{
            height: 36px;
            margin: 0 0 0 10px;
        }
    }
    .table-content{
      margin-top: 16px;
    }
}

.search {
    display: flex;
    justify-content: center;
    align-items: center;
    .my_input {
        width: 500px;
        margin-right: 10px;
    }
    .el-button--primary {
        background-color: $main-color;
        border-color: $main-color;
    }
}

.line-middle {
    // margin-left: 25px;
    margin-top: 45px;
    .tabs-line {
        height: 32px;
        width: 128px;
        border-radius: 0px 2px 2px 0px;
        border: 1px solid #cccccc;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        & > div {
            width: 64px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            cursor: pointer;
        }
        .actived {
            background: #2568ec;
            color: #fff;
        }
    }
    .line-echarts {
        width: 100%;
        height: 370px;
        margin-top: 16px;
        /*&>div{*/
        /*    width: calc(50% - 25px);*/
        /*}*/
        .chart-box1 {
            height: 300px;
        }
    }
    .table-unit {
        table-layout: fixed;
        width: calc(100% - 38px);
        margin-left: 8px;
        border-collapse: collapse;
        border: 1px solid #eee;
        td {
            text-align: center;
            line-height: 24px;
            color: rgba(0, 0, 0, 0.65);
        }
        tr:nth-of-type(1) {
            td:nth-of-type(1) {
                width: 40px;
                span {
                    background-color: #5b8ff9;
                }
            }
        }
        tr:nth-of-type(2) {
            td:nth-of-type(1) {
                width: 40px;
                span {
                    background-color: #5ad8a6;
                }
            }
        }
        span {
            width: 8px;
            height: 8px;
            display: inline-block;
        }
    }
}
.heat-map {
    width: calc(100% - 32px);
    height: 627px;
    margin-left: 16px;
    // background-image: url('../../../../assets/img/siteRatio/bg1.png');
    background-repeat: no-repeat;
    background-size: 100%;
    & > div {
        width: 100%;
        height: 100%;
    }
}

.unit-class {
    font-size: 12px;
    //font-weight: bold;
    font-family: "Consolas";
    color: #c0c4cc;
}
</style>